<template>
  <div class="app-container">
    <el-card>
      <el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('collectionCenter.particulars')" name="detail">
          <!-- 明细页面内容 -->
          <el-form
            ref="formSearch" :model="queryForm" label-position="top"
            size="small"
          >
            <el-row :gutter="10">
              <el-col :span="5">
                <!--  运单号   -->
                <el-form-item prop="selectType">
                  <template slot="label">
                    <div class="selectLabel">
                      <el-select v-model="queryForm.params.selectType" :style="IsWidth1">
                        <el-option key="1" :label="$t('newOrder.waybillNumber')" :value="1" />
                        <el-option key="2" :label="$t('GlobalSetObj.ScanNumber')" :value="2" />
                      </el-select>
                    </div>
                  </template>
                  <el-input
                    v-model="queryForm.params.inputValue"
                    :placeholder="$t('newOrder.PreciseSearch1')"
                    :rows="1"
                    style="width: 100%"
                    type="textarea"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('collectionCenter.receiptDate')">
                  <!--网点入库时 间-->
                  <el-date-picker
                    v-model="timeValue"
                    :end-placeholder="$t('operationCenter.endDate')"
                    :start-placeholder="$t('operationCenter.startDate')"
                    range-separator="~"
                    style="width: 100%"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item :label="$t('collectionCenter.region')">
                  <el-select
                    v-model="queryForm.params.regionIdList"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    collapse-tags
                    filterable
                    multiple
                    style="width: 100%"
                    @change="regionChange"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.id"
                      :label="item.zhName + '（' + item.puName + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 网点所属州 -->
              <el-col :span="4">
                <el-form-item :label="$t('collectionCenter.stateSite1')">
                  <el-select
                    v-model="queryForm.params.stateList"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    collapse-tags
                    filterable
                    multiple
                    style="width: 100%"
                    @change="stateChange"
                  >
                    <el-option
                      v-for="(item, index) in StateList"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 签收网点 -->
              <el-col :span="4">
                <el-form-item :label="$t('collectionCenter.signSite')">
                  <el-select
                    v-model="queryForm.params.siteIdList"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    collapse-tags
                    filterable
                    multiple
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in siteList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="5">
                <!--派送员-->
                <el-form-item :label="$t('orderCenterCont.deliveryPerson')">
                  <el-select
                    v-model="queryForm.params.driverIdList"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    :remote-method="getallDriver"
                    clearable
                    filterable
                    multiple
                    remote
                    reserve-keyword
                    style="width: 100%"
                    @clear="getallDriver('')"
                    @focus="getallDriver1('')"
                  >
                    <el-option
                      v-for="item in userList"
                      :key="item.id"
                      :label="item.username"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 图片 -->
              <el-col :span="3">
                <el-form-item :label="$t('collectionCenter.picture')">
                  <el-select
                    v-model="queryForm.params.photoValid"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    style="width: 100%"
                  >
                    <el-option :label="$t('GlobalSetObj.all')" :value="null" />
                    <el-option :label="$t('collectionCenter.qualified')" :value="1" />
                    <el-option :label="$t('collectionCenter.unqualified')" :value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 签名 -->
              <el-col :span="3">
                <el-form-item :label="$t('collectionCenter.signature')">
                  <el-select
                    v-model="queryForm.params.signatureValid"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    style="width: 100%"
                  >
                    <el-option :label="$t('GlobalSetObj.all')" :value="null" />
                    <el-option :label="$t('collectionCenter.qualified')" :value="1" />
                    <el-option :label="$t('collectionCenter.unqualified')" :value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- POD上传方式筛选 -->
              <el-col :span="3">
                <el-form-item :label="$t('navbar.podUploadMethod')">
                  <el-select
                    v-model="queryForm.params.podUploadType"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    style="width: 100%"
                  >
                    <el-option :label="$t('GlobalSetObj.all')" :value="null" />
                    <el-option :label="$t('navbar.scanBarcode')" :value="1" />
                    <el-option :label="$t('navbar.enterTrackingNumber')" :value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="9" style="margin-top: 27px">
                <div>
                  <el-button
                    icon="el-icon-search" size="small" type="primary"
                    @click="enterSearch"
                  >{{ $t('operationCenter.Procurar') }}
                  </el-button>
                  <el-button icon="el-icon-refresh-left" size="small" @click="resetForm">
                    {{ $t('operationCenter.reset') }}
                  </el-button>
                  <el-button
                    icon="el-icon-upload2"
                    size="small"
                    style="margin-bottom: 10px"
                    type="primary"
                    @click="allExportOrder"
                  >{{ $t('newOrder.export') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
            border
          >
            <el-table-column
              :label="$t('GlobalSetObj.serial')"
              align="center"
              type="index"
              width="80"
            />
            <el-table-column
              v-for="(item, ind) in tableHeaderList"
              :key="ind"
              :align="item.align"
              :label="item.label"
              :min-width="item.width"
              :prop="item.prop"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div
                  v-if="item.prop === 'signatureValName'"
                  @click="imageSee(scope.row.signatureUrl)"
                >
                  <el-tag :type="scope.row.signatureValid === 1 ? 'success' : 'danger'">{{ scope.row.signatureValName }}
                  </el-tag>
                </div>
                <div
                  v-else-if="item.prop === 'photoValName'"
                  @click="imageSee(scope.row.photoUrls)"
                >
                  <el-tag :type="scope.row.photoValid === 1 ? 'success' : 'danger'">{{ scope.row.photoValName }}
                  </el-tag>
                </div>
                <div v-else>{{ scope.row[item.prop] || '--' }}</div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              :current-page.sync="queryForm.pageNumber"
              :page-size.sync="queryForm.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :total="total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: 10px 0"
              @current-change="getCurrentTableData"
              @size-change="getSizeTableData"
            />
          </div>
        </el-tab-pane>
        <!-- 统计 Tab -->
        <el-tab-pane :label="$t('collectionCenter.statistics')" lazy name="statistics">
          <el-form
            ref="formSearchStat" :model="queryFormStat" label-position="top"
            size="small"
          >
            <!-- 搜索条件：一行显示 -->
            <el-row :gutter="10">
              <el-col :span="5">
                <el-form-item :label="$t('collectionCenter.receiptDate')">
                  <el-date-picker
                    v-model="timeValueStat"
                    :end-placeholder="$t('operationCenter.endDate')"
                    :start-placeholder="$t('operationCenter.startDate')"
                    range-separator="~"
                    style="width: 100%"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('collectionCenter.region')">
                  <el-select
                    v-model="queryFormStat.params.regionIdList"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    clearable
                    collapse-tags
                    filterable
                    multiple
                    style="width: 100%"
                    @change="regionChangeStat"
                  >
                    <el-option
                      v-for="item in regionList"
                      :key="item.id"
                      :label="item.zhName + '（' + item.puName + '）'"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$t('collectionCenter.stateSite1')">
                  <el-select
                    v-model="queryFormStat.params.stateList"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    clearable
                    collapse-tags
                    filterable
                    multiple
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in StateListStat"
                      :key="index"
                      :label="item.label"
                      :value="item.label"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="margin-top: 27px">
                <el-button
                  icon="el-icon-search"
                  size="small"
                  type="primary"
                  @click="enterSearchStat"
                >{{ $t('operationCenter.Procurar') }}
                </el-button>
                <el-button icon="el-icon-refresh-left" size="small" @click="resetFormStat">
                  {{ $t('operationCenter.reset') }}
                </el-button>
                <el-button
                  icon="el-icon-upload2"
                  size="small"
                  style="margin-bottom: 10px; margin-left: 10px"
                  type="primary"
                  @click="exportStatData"
                >{{ $t('newOrder.export') }}
                </el-button>
              </el-col>
            </el-row>
          </el-form>
          <el-table
            :cell-class-name="cellClassName"
            :data="tableDataStat"
            :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
            :row-class-name="tableRowClassName"
            :span-method="objectSpanMethod"
            border
          >
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.receiptDate')"
              prop="statDate"
            />
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.region')"
              prop="regionName"
            />
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.stateSite1')"
              prop="stateName"
            />
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.signTotal')"
              prop="totalCount"
            >
              <template slot-scope="scope">
                <span>{{ formatNumber(scope.row.totalCount) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.qualifiedCount')"
              prop="qualifiedCount"
            >
              <template slot-scope="scope">
                <span>{{ formatNumber(scope.row.qualifiedCount) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.qualificationRate')"
              prop="qualifiedRate"
            >
              <template slot-scope="scope">
                <span>{{ calculateQualifiedRate(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.unqualifiedCount')"
              prop="unqualifiedCount"
            >
              <template slot-scope="scope">
                <span>{{ formatNumber(scope.row.unqualifiedCount) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :align="'center'"
              :label="$t('collectionCenter.unqualifiedRate')"
              prop="unqualifiedRate"
            >
              <template slot-scope="scope">
                <span>{{ calculateUnqualifiedRate(scope.row) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 新增的指定单号审核 Tab -->
        <el-tab-pane :label="$t('podVerification.tabDesignatedAudit')" lazy name="designatedAudit">
          <designated-audit />
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <imageSeeDialog ref="imageSeeDialogRef" />
  </div>
</template>

<script>
import { getLgAreaListData, regionQueryList, selectInfoByStateTwo } from '@/api/orderApi';
import dayjs from 'dayjs';
import { signRescissiongetPmUserList } from '@/api/resources';
import { goResourceTaskList, goRWExportList } from '@/utils/goExportList';
import { Loading } from 'element-ui';
import imageSeeDialog from '@/components/imageSeeDialog/index.vue';
import DesignatedAudit from './component/DesignatedAudit'; // 请根据实际路径修改
import {
  podStatisticsExport,
  podValidationExport,
  podValidationPage,
  podValidationStatistics
} from '@/api/newExpressAPI';

export default {
  name: 'ReturnDataMonitoring',
  components: {
    imageSeeDialog,
    DesignatedAudit
  },
  data() {
    return {
      activeTab: 'detail',
      statSearched: false, // 统计Tab是否已查询过
      allSiteListCache: null,
      sitesByRegionAndState: {},
      regionList: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          driverIdList: [],
          selectType: 1,
          inputValue: '',
          regionIdList: [],
          stateList: [],
          siteIdList: [],
          photoValid: null,
          signatureValid: null,
          podUploadType: null
        }
      },
      tableData: [],
      total: 0,
      StateList: [], // 州
      tableHeaderList: [
        {
          label: this.$t('GlobalSetObj.waybillNumber'),
          prop: 'waybillNumber',
          width: 170
        },
        {
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanOrderNumber',
          width: 170
        },
        // 签名
        { label: this.$t('collectionCenter.signature'), prop: 'signatureValName', width: 150 }, // 不合格原因
        // 签名不合格类型
        {
          label: this.$t('navbar.invalidSignatureType'),
          prop: 'signatureInvalidTypeName',
          width: 150
        },
        {
          label: this.$t('navbar.invalidSignatureReason'),
          prop: 'signInvalidDescription',
          width: 150
        },
        // 图片
        { label: this.$t('collectionCenter.picture'), prop: 'photoValName', width: 150 },
        // 图片不合格类型
        {
          label: this.$t('navbar.invalidImageType'),
          prop: 'photoInvalidTypeName',
          width: 150
        },
        // 图片不合格原因
        {
          label: this.$t('navbar.invalidImageReason'),
          prop: 'photoInvalidDescription',
          width: 150
        },
        // POD上传方式
        { label: this.$t('navbar.podUploadMethod'), prop: 'podUploadTypeName', width: 150 },
        // 大区 Região
        { label: this.$t('collectionCenter.region'), prop: 'regionName', width: 100 },
        // 网点所属州
        { label: this.$t('collectionCenter.stateSite1'), prop: 'stateName', width: 150 },
        // 签收网点
        { label: this.$t('collectionCenter.signSite'), prop: 'siteName', width: 150 },
        // 派送员
        { label: this.$t('orderCenterCont.deliveryPerson'), prop: 'driverName', width: 160 },
        // 签收日期
        { label: this.$t('collectionCenter.receiptDate'), prop: 'signedTime', width: 170 },
        // 客户
        { label: this.$t('collectionCenter.client'), prop: 'customerName', width: 150 },
        // 商户
        { label: this.$t('collectionCenter.CommercialOwner'), prop: 'merchantName', width: 150 }
      ],
      timeValue: [this.getAWeek().startDate, this.getAWeek().endDate],
      siteList: [],
      TransferList: [],
      strARR: ['returnCount', 'secondaryStorageCount'],
      imageList: [],
      userList: [],
      // 是否格式化成巴西时间
      isTormat: false,
      // 统计 Tab 相关数据
      queryFormStat: {
        params: {
          regionIdList: [],
          stateList: []
        }
      },
      tableDataStat: [],
      timeValueStat: [this.getAWeek().startDate, this.getAWeek().endDate],
      StateListStat: []
    };
  },
  computed: {
    IsWidth1() {
      return {
        width: this.isTormat ? '180px' : '100px'
      };
    }
  },
  created() {
    // 获取加盟商选项
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getAddress();
    this.getSearch(1);
    this.getSiteList();
    this.getRegion();
    this.getallDriver();
  },
  methods: {
    regionChange(val) {
      // 大区为多选时，获取所选大区下的所有州
      this.queryForm.params.stateList = [];
      this.queryForm.params.siteIdList = [];
      if (!val || val.length === 0) {
        this.getAddress();
        this.getSiteList();
        return;
      }
      const allStates = [];
      const allSites = [];
      val.forEach((regionId) => {
        const selectedRegion = this.regionList.find((item) => item.id === regionId);
        console.log(selectedRegion, 'selectedRegion');
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          // 将州列表添加到总列表中
          selectedRegion.states.forEach((state) => {
            // 避免重复添加
            if (!allStates.some((s) => s.label === state)) {
              allStates.push({
                label: state
              });
            }
          });
          // 将州列表添加到总列表中
          selectedRegion.sites.forEach((site) => {
            // 避免重复添加
            if (!allSites.some((s) => s.id === site.id)) {
              allSites.push(site);
            }
          });
        }
      });
      this.StateList = allStates;
      this.siteList = allSites;
    },
    stateChange(val) {
      // 1. 重置网点列表（关键：无论是否有选中值，先清空旧数据）
      this.queryForm.params.siteIdList = [];
      this.siteList = []; // ✅ 核心修复：每次切换先清空，避免残留旧数据
      const allSites = [];
      // 2. 无选中州时，重置网点列表并返回
      if (!val || val.length === 0) {
        this.getSiteList();
        return;
      }
      // 3. 遍历选中的州，收集对应网点
      val.forEach((state) => {
        const selectedRegion = this.regionList.find((item) => {
          return item.states.includes(state);
        });
        console.log(selectedRegion, 'selectedRegion');
        // 4. 仅当找到对应区域且有网点时，才添加到allSites
        if (
          selectedRegion &&
          Array.isArray(selectedRegion.sites) &&
          selectedRegion.sites.length > 0
        ) {
          selectedRegion.sites.forEach((site) => {
            // 去重：避免同一网点重复添加
            if (state === site.state) {
              if (!allSites.some((s) => s.id === site.id)) {
                allSites.push(site);
              }
            }
          });
        }
      });
      this.siteList = allSites;
    },
    // Tab 切换
    handleTabClick(tab) {
      if (tab.name === 'statistics') {
        if (this.StateListStat.length === 0) {
          this.getAddressStat();
        }
        // 只有第一次点击统计Tab时才查询
        if (!this.statSearched) {
          this.statSearched = true;
          this.getSearchStat();
        }
      }
    },
    // 统计 Tab - 大区切换
    regionChangeStat(val) {
      this.queryFormStat.params.stateList = [];
      if (!val || val.length === 0) {
        this.getAddressStat();
        return;
      }
      const allStates = [];
      val.forEach((regionId) => {
        const selectedRegion = this.regionList.find((item) => item.id === regionId);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          selectedRegion.states.forEach((state) => {
            if (!allStates.some((s) => s.label === state)) {
              allStates.push({
                label: state
              });
            }
          });
        }
      });
      this.StateListStat = allStates;
    },
    // 统计 Tab - 查询条件整理
    queryParamStat() {
      const params = {
        beginDate: null,
        endDate: null,
        regionIdList: this.queryFormStat.params.regionIdList,
        stateList: this.queryFormStat.params.stateList
      };
      if (this.timeValueStat && this.timeValueStat.length > 0) {
        params.beginDate = this.timeValueStat[0];
        params.endDate = this.timeValueStat[1];
      }
      return params;
    },
    // 统计 Tab - 获取统计数据
    getSearchStat() {
      const data = this.queryParamStat();
      if (!this.timeValueStat || this.timeValueStat.length === 0) {
        this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
        return;
      }
      podValidationStatistics(data).then((res) => {
        if (res.code === 200) {
          const responseData = res.data || [];
          // 只需要年月日，前端直接切割时间部分
          responseData.forEach((item) => {
            if (item.statDate) {
              item.statDate = item.statDate.split(' ')[0];
            }
          });
          // 添加汇总行
          const processedData = this.addSummaryRows(responseData);
          // 添加总计行到数据开头
          const totalRow = this.calculateTotalSummary(processedData);
          totalRow.isTotal = true;
          this.tableDataStat = [totalRow, ...processedData];
        }
      });
    },
    // 统计 Tab - 导出
    exportStatData() {
      const data = this.queryParamStat();
      if (!this.timeValueStat || this.timeValueStat.length === 0) {
        this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
        return;
      }
      podStatisticsExport(data).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    // 统计 Tab - 搜索
    enterSearchStat() {
      this.getSearchStat();
    },
    // 统计 Tab - 重置
    resetFormStat() {
      this.queryFormStat = {
        params: {
          regionIdList: [],
          stateList: []
        }
      };
      this.timeValueStat = [this.getAWeek().startDate, this.getAWeek().endDate];
      this.getSearchStat();
    },
    // 计算合格率
    calculateQualifiedRate(row) {
      const total = row.totalCount || 0;
      const qualified = row.qualifiedCount || 0;
      if (total === 0) return this.$i18n.locale === 'zh' ? '0.00%' : '0,00%';
      let rate = ((qualified / total) * 100).toFixed(2);
      if (this.$i18n.locale !== 'zh') {
        rate = rate.replace('.', ',');
      }
      return rate + '%';
    },
    // 计算不合格率
    calculateUnqualifiedRate(row) {
      const total = row.totalCount || 0;
      const unqualified = row.unqualifiedCount || 0;
      if (total === 0) return this.$i18n.locale === 'zh' ? '0.00%' : '0,00%';
      let rate = ((unqualified / total) * 100).toFixed(2);
      if (this.$i18n.locale !== 'zh') {
        rate = rate.replace('.', ',');
      }
      return rate + '%';
    },
    // 添加汇总行（州总计）
    addSummaryRows(data) {
      if (!data || data.length === 0) return data;

      const result = [];
      const groupedByDate = {};

      // 按日期分组（优先级最高）
      data.forEach((item) => {
        if (!groupedByDate[item.statDate]) {
          groupedByDate[item.statDate] = [];
        }
        groupedByDate[item.statDate].push(item);
      });

      // 对每个日期内的数据按大区进行分组
      Object.keys(groupedByDate).forEach((date) => {
        const dateData = groupedByDate[date];
        const groupedByRegionInDate = {};

        // 按大区再次分组
        dateData.forEach((item) => {
          if (!groupedByRegionInDate[item.regionName]) {
            groupedByRegionInDate[item.regionName] = [];
          }
          groupedByRegionInDate[item.regionName].push(item);
        });

        // 为每个大区添加州总计行
        Object.keys(groupedByRegionInDate).forEach((regionName) => {
          const regionData = groupedByRegionInDate[regionName];

          // 只有当该大区对应的数据超过一行时，才添加州总计行
          if (regionData.length > 1) {
            // 计算该大区的州汇总数据
            const summaryRow = this.calculateRegionSummary(regionData);
            summaryRow.isSummary = true; // 标记为汇总行

            // 将州总计行放在该大区数据的最前面
            result.push(summaryRow);
          }

          // 添加原始数据
          result.push(...regionData);
        });
      });

      return result;
    },
    // 计算区域汇总数据
    calculateRegionSummary(regionData) {
      const summary = {
        statDate: regionData[0].statDate,
        regionId: regionData[0].regionId,
        regionName: regionData[0].regionName,
        stateName: this.$t('collectionCenter.stateSummary'),
        isSummary: true
      };
      const signedCount = regionData.reduce((sum, item) => sum + Number(item.totalCount || 0), 0);
      const qualifiedCount = regionData.reduce(
        (sum, item) => sum + Number(item.qualifiedCount || 0),
        0
      );
      const unqualifiedCount = regionData.reduce(
        (sum, item) => sum + Number(item.unqualifiedCount || 0),
        0
      );
      summary.totalCount = signedCount;
      summary.qualifiedCount = qualifiedCount;
      summary.unqualifiedCount = unqualifiedCount;
      return summary;
    },
    // 计算总计行
    calculateTotalSummary(data) {
      const totalRow = {
        statDate: `${this.timeValueStat[0]}~${this.timeValueStat[1]}`,
        regionName: this.$t('collectionCenter.total'),
        stateName: '',
        isTotal: true
      };
      const filteredData = data.filter((item) => !item.isSummary);
      const signedCount = filteredData.reduce((sum, item) => sum + Number(item.totalCount || 0), 0);
      const qualifiedCount = filteredData.reduce(
        (sum, item) => sum + Number(item.qualifiedCount || 0),
        0
      );
      const unqualifiedCount = filteredData.reduce(
        (sum, item) => sum + Number(item.unqualifiedCount || 0),
        0
      );
      totalRow.totalCount = signedCount;
      totalRow.qualifiedCount = qualifiedCount;
      totalRow.unqualifiedCount = unqualifiedCount;
      return totalRow;
    },
    // 合并行
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        // 0列: 日期列，如果有总计需要返回，但不一定跨列，总计是单独一行
        if (row.isTotal) {
          return [1, 1];
        }
        return this.calculateSpan1(row, rowIndex, 'statDate');
      }
      if (columnIndex === 1) {
        // 1列: 大区列
        if (row.isTotal) {
          return [1, 1];
        }
        return this.calculateSpan2(row, rowIndex, 'regionName', 'statDate');
      }
      if (columnIndex === 2) {
        // 2列: 州列
        if (row.isTotal) {
          return [1, 1];
        }
        if (row.isSummary) {
          return [1, 1]; // 大区/州总计行只占用一行
        }
        return this.calculateSpan3(row, rowIndex, 'stateName', 'regionName', 'statDate');
      }
      return [1, 1];
    },
    calculateSpan3(row, rowIndex, prop, parentProp, grandParentProp) {
      if (
        rowIndex > 0 &&
        row[prop] === this.tableDataStat[rowIndex - 1][prop] &&
        row[parentProp] === this.tableDataStat[rowIndex - 1][parentProp] &&
        row[grandParentProp] === this.tableDataStat[rowIndex - 1][grandParentProp]
      ) {
        return [0, 0];
      } else {
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableDataStat.length; i++) {
          if (
            this.tableDataStat[i][prop] === row[prop] &&
            this.tableDataStat[i][parentProp] === row[parentProp] &&
            this.tableDataStat[i][grandParentProp] === row[grandParentProp]
          ) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
    },
    calculateSpan1(row, rowIndex, prop) {
      if (rowIndex > 0 && row[prop] === this.tableDataStat[rowIndex - 1][prop]) {
        return [0, 0];
      } else {
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableDataStat.length; i++) {
          if (this.tableDataStat[i][prop] === row[prop]) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
    },
    calculateSpan2(row, rowIndex, prop, parentProp) {
      if (
        rowIndex > 0 &&
        row[prop] === this.tableDataStat[rowIndex - 1][prop] &&
        row[parentProp] === this.tableDataStat[rowIndex - 1][parentProp]
      ) {
        return [0, 0];
      } else {
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableDataStat.length; i++) {
          if (
            this.tableDataStat[i][prop] === row[prop] &&
            this.tableDataStat[i][parentProp] === row[parentProp]
          ) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
    },
    // 行样式
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        // 第一行（总计行），整行字体加粗
        return 'total-row';
      } else if (row.isSummary) {
        // 大区/州总计汇总行，应用特殊样式
        return 'state-summary-row';
      }
      return '';
    },
    // 单元格样式
    cellClassName({ row, column, rowIndex, columnIndex }) {
      // 大区总计行或整体总计行，从第三列（index >= 2）开始应用背景
      if ((row.isSummary || row.isTotal) && columnIndex >= 2) {
        return 'state-summary-cell';
      }
      return '';
    },
    // 统计 Tab - 获取州列表
    getAddressStat() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateListStat = res.data.map((item) => {
            return {
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 点击查看 图片
    imageSee(row) {
      console.log(row, 'row');
      const imageArr = row;
      if (imageArr && imageArr.length > 0) {
        this.imageList = imageArr.map((item) => {
          return item + '?imageMogr2/thumbnail/2000x2000>/quality/80/format/jpg/ignore-error/1';
        });
        this.$refs.imageSeeDialogRef.showImageFun(this.imageList);
      }
    },
    // 查询条件整理
    queryParam() {
      const params = {
        beginTime: null,
        endTime: null,
        siteIdList: this.queryForm.params.siteIdList,
        stateList: this.queryForm.params.stateList,
        regionIdList: this.queryForm.params.regionIdList,
        driverIdList: this.queryForm.params.driverIdList,
        waybillNumberList: [],
        scanOrderNumberList: [],
        photoValid: this.queryForm.params.photoValid,
        signatureValid: this.queryForm.params.signatureValid,
        podUploadType: this.queryForm.params.podUploadType
      };
      if (this.timeValue && this.timeValue.length > 0) {
        params.beginTime = this.timeValue[0];
        params.endTime = this.timeValue[1];
      }
      const inputValList = [];
      if (this.queryForm.params.inputValue) {
        // 单号格式化，去除空格
        const orderNumber = this.queryForm.params.inputValue.split(/[(\r\n)\r\n]+/);
        orderNumber.map((item) => {
          if (item) {
            inputValList.push(item.trim());
          }
        });
      }
      if (this.queryForm.params.selectType === 1) {
        params.waybillNumberList = inputValList;
      } else {
        params.scanOrderNumberList = inputValList;
      }
      return params;
    },
    // 获取加盟商时效统计列表
    getSearch(val) {
      // 有运单号/扫描号时清空时间范围，跳过时间校验，允许直接搜索
      if (this.queryForm.params.inputValue) {
        this.timeValue = [];
      } else if (!this.timeValue || this.timeValue.length === 0) {
        this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
        return;
      }
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: this.queryParam()
      };
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      podValidationPage(data)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records;
            if (val === 1) {
              loading.close();
            }
          }
        })
        .catch(() => {
          if (val === 1) {
            loading.close();
          }
        });
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    getallDriver(name) {
      const data = {
        operateUserName: name
      };
      signRescissiongetPmUserList(data).then((res) => {
        if (res.code === 200) {
          this.userList = res.data;
        }
      });
    },
    getallDriver1() {
      if (this.userList.length === 0) {
        this.getallDriver('');
      }
    },
    // 搜索、重置
    resetForm() {
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          selectType: 1,
          driverIdList: [],
          regionIdList: [],
          stateList: [],
          siteIdList: []
        }
      };
      this.timeValue = [this.getAWeek().startDate, this.getAWeek().endDate];
      this.getSearch();
    },
    allExportOrder() {
      // 有运 单号/扫描号时清空时间范围，跳过时间校验，允许直接导出
      if (this.queryForm.params.inputValue) {
        this.timeValue = [];
      } else if (!this.timeValue || this.timeValue.length === 0) {
        this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
        return;
      }
      const data = this.queryParam();
      podValidationExport(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 格式化数字（根据语言环境千分位）
    formatNumber(num) {
      if (num === null || num === undefined || num === '--') {
        return '--';
      }
      // 中文环境：用逗号千分位
      if (this.$i18n.locale === 'zh') {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      // 葡语环境：用句号千分位
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    // 获取最近7天时间
    getAWeek() {
      return {
        endDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      };
    },
    // 页码变化翻页
    getCurrentTableData(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 每页显示数量变化
    getSizeTableData(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    // 大区
    getRegion() {
      regionQueryList(3).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    groupSitesByRegionAndState() {
      const grouped = {};
      this.regionList.forEach((region) => {
        if (!grouped[region.id]) {
          grouped[region.id] = {};
        }

        region.sites.forEach((site) => {
          const key = site.state; // 区分大小写
          if (!grouped[region.id][key]) {
            grouped[region.id][key] = [];
          }
          grouped[region.id][key].push(site);
        });
      });

      this.sitesByRegionAndState = grouped;
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 获取网点列表
    getSiteList() {
      if (this.allSiteListCache) {
        this.siteList = this.allSiteListCache;
        return Promise.resolve();
      }
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const data = {};
      selectInfoByStateTwo(data)
        .then((res) => {
          if (res.code === 200) {
            this.allSiteListCache = res.data.siteList; // 缓存全部网点
            this.siteList = [...this.allSiteListCache]; // 初始化为全量数据
          }
        })
        .finally(() => {
          load.close();
        });
    }
  }
};
</script>

<style scoped>
::v-deep .el-tab-pane {
  width: 100%;
}

.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.table-active {
  color: #00a551;
  cursor: pointer;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

/* 第一行总计行：除序号列外所有列加粗 */
::v-deep .el-table .total-row > td:nth-child(n + 2),
::v-deep .el-table .total-row .el-table__cell:nth-child(n + 2) {
  font-weight: bold;
  font-size: 15px;
}

/* 州总计行：加粗 */
::v-deep .el-table .state-summary-row > td {
  font-weight: bold;
  font-size: 15px;
}

/* 州总计行的特定单元格加粗 */
::v-deep .el-table .state-summary-cell {
  font-weight: bold !important;
  font-size: 15px;
}
</style>
